export default "__VITE_ASSET__31600eaf__"